<script>
    import emailjs from "emailjs-com";
    import { store } from "../../store";

    let sending = false;

    function handleSubmit() {
        if(sending) return;

        sending = true;

        var firstName = document.querySelector(
            "#contact input[name=first-name]"
        ).value;
        var lastName = document.querySelector(
            "#contact input[name=last-name]"
        ).value;
        var email = document.querySelector("#contact input[name=email]").value;
        var description = document.querySelector(
            "#contact textarea[name=description]"
        ).value;

        if (!firstName) {
            alert("Please input your first name");
            document.querySelector("#contact input[name=first-name]").focus();
            return;
        }
        if (!lastName) {
            alert("Please input your last name");
            document.querySelector("#contact input[name=last-name]").focus();
            return;
        }
        if (!email) {
            alert("Please input your email");
            document.querySelector("#contact input[name=email]").focus();
            return;
        }
        if (!description) {
            alert("Please input your description of your request");
            document
                .querySelector("#contact textarea[name=description]")
                .focus();
            return;
        }

        emailjs
            .sendForm(
                "service_5t8ch6n",
                "template_bzbr5es",
                "#contact",
                "user_kNgC8L6EptFxkxNso9rjr"
            )
            .then(
                (result) => {
                    console.log(result.text);
                    sending = false;
                },
                (error) => {
                    console.log(error.text);
                    sending = false;
                }
            );
    }
</script>

<form
    id="contact"
    class="form"
    style={`
        width: ${$store.type === 'pc' ? ($store.r *950) : $store.r *500}px; 
        height: ${$store.type === 'pc' ? ($store.r * 400) : $store.r *300}px; 
        margin-top: ${$store.r *20}px`
    }
>
    <div class="d-flex flex-row form-row">
        <input
            name="first-name"
            type="text"
            class="form-control"
            placeholder="First Name"
            style={`padding: ${$store.r *30}px`}
        />
        <input
            name="last-name"
            type="text"
            class="form-control"
            placeholder="Last Name"
            style={`padding: ${$store.r *30}px`}
        />
    </div>

    <div class="d-flex form-row">
        <input
            name="email"
            type="email"
            class="form-control"
            placeholder="E-mail"
            style={`padding: ${$store.r *30}px`}
        />
    </div>

    <div class="d-flex form-row">
        <textarea
            name="description"
            class="form-control"
            placeholder="Type your message here"
            style={`height: ${$store.r *150}px; padding: ${$store.r *30}px`}
        />
    </div>
</form>

<style>
    .form {
        width: 950px;
        margin: auto;
    }

    .form-row {
        gap: 20px;
        margin-bottom: 20px;
    }

    .form input {
        padding: 30px;
        border-radius: 20px;
        flex: 1;

        font-size: 1.2vw;
    }

    .form textarea {
        padding: 30px;
        height: 250px;
        border-radius: 20px;
        font-size: 1.2vw;
    }

    @media screen and (max-width: 640px) {
        .form input {
            font-size: 3vw;
        }

        .form textarea {
            font-size: 3vw;
        }

    }
</style>
